export const darkGrey = '#2F2F2F'
export const red = '#D0021B'
export const grey = '#A7A7A7'
export const lightGrey = '#E5E5E5'
